import { type RcFile } from 'antd/es/upload'
import Axios from 'axios'

import { type UploadFileResult } from '../models'

import { getUploadSignedUrl } from './get-upload-signed-url'

export const uploadFile = async (file: RcFile): Promise<UploadFileResult> => {
  // アップロード先のURLを取得
  const { key, signedUrl } = await getUploadSignedUrl()

  // ファイルをアップロード
  await Axios.create().put(signedUrl, file, {
    transformRequest: (data) => data,
    headers: {
      'Content-Type': file.type
    }
  })
  return {
    key,
    name: file.name
  }
}
